import { render, staticRenderFns } from "./InfectedFileDialog.vue?vue&type=template&id=106accc6&scoped=true"
import script from "./InfectedFileDialog.vue?vue&type=script&lang=js"
export * from "./InfectedFileDialog.vue?vue&type=script&lang=js"
import style0 from "./InfectedFileDialog.vue?vue&type=style&index=0&id=106accc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106accc6",
  null
  
)

export default component.exports